import { useEffect } from 'react';
// @ts-ignore 3rd party plugin
import { Gradient } from 'assets/js/Gradient.js';
import { useCurrentCampaign } from 'hooks/useCurrentCampaign';
import { useStore } from 'hooks/useStore';

const GradientCanvas = () => {
  const { campaignId } = useCurrentCampaign();
  const { liveDisplaySettings } = useStore(state => {
    return {
      liveDisplaySettings: state.campaigns[campaignId]
        ? state.campaigns[campaignId].liveDisplaySettings
        : state.campaigns.default.liveDisplaySettings,
    };
  });

  useEffect(() => {
    const gradient = new Gradient();
    gradient.initGradient('#gradient-canvas');
    return () => {
      gradient.disconnect();
    };
  }, [liveDisplaySettings.theme.name]);

  return (
    <canvas
      id="gradient-canvas"
      className={`theme-${liveDisplaySettings.theme.name} pointer-events-none absolute -z-10 h-full w-full`}
      data-transition-in
      style={{
        background: `linear-gradient(
        135deg,
        var(--gradient-color-1),
        var(--gradient-color-2),
        var(--gradient-color-3),
        var(--gradient-color-4)
      )`,
      }}
    />
  );
};

export { GradientCanvas };
